import { useQuery } from "@apollo/client";

import { MapEditorFeatureCreateDialog_GetOptionsDocument } from "../queries.generated";

export function useFeatureCreateDialogData({ open, projectId }: { open: boolean; projectId: string }) {
    const { data, loading } = useQuery(MapEditorFeatureCreateDialog_GetOptionsDocument, {
        variables: { projectId },
        skip: !open,
    });

    return {
        data: {
            researchTypes: data?.settingsResearchTypeGetAll.data ?? [],
            protocols: data?.protocolGetAll.data ?? [],
        },
        loading,
    };
}
